import { Button, PasswordInput } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../../api/client";
import { errorMessage } from "../../shared/session/errors";
import { FormError, Notice, Page } from "../../shared/ui/Page";

export function ResetPasswordPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { response, error } = await api.POST("/auth/reset-password", {
      body: { token: params.get("token") ?? "", password },
    });
    if (response.ok) setDone(true);
    else setError(errorMessage(error, t("error.generic")));
  };
  return (
    <Page title={t("reset.title")}>
      {done ? (
        <>
          <Notice>{t("reset.done")}</Notice>
          <Button component={Link} to="/signin">
            {t("reset.sign_in")}
          </Button>
        </>
      ) : (
        <form onSubmit={submit}>
          <PasswordInput
            label={t("reset.password")}
            description={t("signup.password_hint")}
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            required
            mb="md"
          />
          <FormError message={error} />
          <Button type="submit" fullWidth mt="sm">
            {t("reset.submit")}
          </Button>
        </form>
      )}
    </Page>
  );
}
